import React from 'react';

interface PerksCardProps {
    title: string;
    description: string;
    reward: string;

    imageUrl?: string;
    logoUrl?: string;
    label?: string;
    status?: string;
    learnMoreUrl?: string;

    handleSelect: () => void
}

const PerksCard: React.FC<PerksCardProps> = ({
    imageUrl,
    logoUrl,
    label = 'Discount',
    title,
    description,
    reward,
    status = 'Redeem',
    learnMoreUrl = '#',
    handleSelect,
}) => {
    return (
        <div className="rounded-xl font-medium border overflow-hidden shadow-sm bg-white">
            <div className="relative">
                <img src={imageUrl} alt="Perk" className="w-full h-44 object-cover" />

                {/* Label */}
                <div className="absolute top-3 left-3 bg-white text-sm p-1 rounded-lg shadow">
                    {label}
                </div>

                {/* Logo */}
                <div className="absolute bottom-5 left-3 w-10 h-10 bg-white rounded-full shadow flex items-center justify-center">
                    <img src={logoUrl} alt="Logo" className="w-full" />
                </div>
            </div>

            <div className="pt-5 px-4 pb-4">
                <h3 className="mb-2">{title}</h3>
                <p className="text-sm text-gray-500 mb-2">{description}</p>
                <p className="font-semibold mb-4">{reward}</p>

                <div className="flex justify-between items-center text-sm">
                    <button onClick={handleSelect} className={`${status === 'Activated' && '!bg-green-100 !text-green-500'} button-1 !text-sm !py-2`}>
                        {status}
                    </button>
                    {/* <a href={learnMoreUrl} className="text-gray-500 underline">
                        Learn more
                    </a> */}
                </div>
            </div>
        </div>
    );
};

export default PerksCard;
